import { useEffect, useState } from "react";
import {
  TextField,
  Button,
  Alert,
  Typography,
  Paper,
  Box,
  CircularProgress,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { fetchUserPermissions } from "../utils/fetchUserPermissions";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

console.log("API Base URL:", BASE_URL);

export default function LoginForm() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // Check for token and redirect to dashboard if present
  useEffect(() => {
    const checkSession = async () => {
      try {
        const res = await fetch(`${BASE_URL}/api/me`, {
          method: "GET",
          credentials: "include", // sends HttpOnly cookie automatically
        });
        if (res.ok) {
          const data = await res.json();
          // Optionally store permissions in React context
          // setPermissions(data.permissions);
          navigate("/dashboard", { replace: true });
        }
      } catch (err) {
        console.log("No active session");
      }
    };

    checkSession();
  }, [navigate]);


  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
console.log("handleSubmit", BASE_URL);
    try {
      const res = await fetch(`${BASE_URL}/api/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password, bo_id: "BFXIND" }),
        credentials: "include", // Important for sending HttpOnly cookie
      });

      const data = await res.json();
      console.log("handle submit after login",data);
      if (res.ok) {
        // localStorage.setItem("token", data.token);
        // localStorage.removeItem("permissions"); // clear old permissions     
        // Store permissions
        const permissions = await fetchUserPermissions();
        console.log("Fetched permissions:", permissions);
        navigate("/dashboard", { replace: true }); // Only navigate after storing permissions
      } else {
        setError(data.message || "Login failed");
      }
    } catch (err) {
      setError("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: "75vh",
        width: "100vw",
        bgcolor: "#f0f2f5",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Paper elevation={4} sx={{ p: 4, width: 300, borderRadius: 3 }}>
        <Typography variant="h6" fontWeight="bold" gutterBottom align="center">
          BFx Login
        </Typography>

        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        <form onSubmit={handleSubmit}>
          <TextField
            label="Email"
            type="email"
            fullWidth
            size="small"
            margin="normal"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <TextField
            label="Password"
            type="password"
            fullWidth
            size="small"
            margin="normal"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <Button
            type="submit"
            variant="contained"
            fullWidth
            sx={{ mt: 2, height: 45 }}
            disabled={loading}
          >
            {loading ? <CircularProgress size={24} /> : "Login"}
          </Button>
        </form>
      </Paper>
    </Box>
  );
}